
export default function Support() {
    return <>
        <div className="container body-text">
            <div className="annual-contribution-page">
                <h2>Opportunities to support our community</h2>

                <h3>The Lil Pantry</h3>
                <div>
                    <p>Located across from Pleasant Ridge Montessori.</p> 
                    <p>Always accepting donations including canned goods (tuna, chicken, fruits/veggies, beans), peanut butter, boxed pasta/rice, granola bars, toiletries, cleaning supplies, diapers, feminine hygiene products, etc. welcome. Please do not donate glass, perishable, opened, expired or for pets. No medications, alcohol or soda.</p>
                </div>
                <h3>Small Business Owners</h3>
                <p> Many of our neighbors are small business owners, handy around the house, and are willing to help out. If you need services or have a friend who does, please post to the Ridgewood Civic (Cincinnati) Facebook message.</p>
                <h3>Ridge Day</h3>
                <p>An annual celebration of Pleasant Ridge in Pleasant Ridge! This event is usually held on the first saturday in August. Featuring food and beer trucks, live music, and dozens of vendors many of which live right here in our community. </p>
                <hr></hr>
                <h2>Annual Neighborhood Contribution</h2>
                <p>Your annual contribution helps us maintain and enhance our wonderful community.</p>
                <div className="benefits-section">
                    <h3>Your Contributions Support:</h3>
                    <ul>
                        <li>Neighborhood social events and block parties</li>
                        <li>Seasonal decorations and beautification projects</li>
                    </ul>
                </div>
                <div className="contribution-section">
                    <h3>Contribution Details</h3>
                    <strong><h4>Annual Dues:</h4></strong>
                        <ul>
                            <li>$50 per family</li>
                            <li>$40 per couple</li>
                            <li>$25 per single</li>
                        </ul>
                    <strong><h4>Preferred Payment Methods:</h4></strong>
                        <ul>
                            <li>Check payable to: Ridgewood Civic Association</li>
                            <li>Mail or deliver to: Sonya Persky, 6504 Crestridge Circle</li>
                            <li>Send through: <a href="https://venmo.com/code?user_id=1785046566436864102&created=1761584385.1191502" target="_blank">Venmo</a></li>
                        </ul>
                    <h4>Fiscal Year: September - August</h4>
                    <ul>
                        <li>Contributions are usually collected in late summer for the upcoming year.</li>
                    
                    </ul>
                </div>
                <div className="financial-section">
                    <h3>Financial Report</h3>
                    <p>Our 2025-2026 annual financial report is available below, showing how your dues benefit our neighborhood.</p>

                </div>

                <table className="financial-table">
                    <colgroup>
                        <col className='first-column' />
                        <col className='second-column' />
                    </colgroup>
                    <h4>Revenue</h4>
                    <tbody>
                    <tr>
                        <td>Neighbor Dues</td>
                        <td>3,400</td>
                    </tr>
                    <tr>
                        <td>Columbia Township Support</td>
                        <td>500</td>
                    </tr>
                    <tr className="divider">
                        <td colSpan={2}></td>
                    </tr>

                    <tr>
                        
                        <td>Total Revenue</td>
                        <td>3,900</td>
                    </tr>
                    <tr className="divider-no-boarder">
                        <td colSpan={2}></td>
                    </tr>
                    <h4>Expenses</h4>
                    <tr>
                        <td>Annual Block Party</td>
                        <td>2,100</td>
                    </tr>
                    <tr>
                        <td>Other Neighborhood Events</td>
                        <td>1,550</td>
                    </tr>
                    <tr>
                        <td>Seasonal Decorations</td>
                        <td>150</td>
                    </tr>
                    <tr>
                        <td>Office Expenses</td>
                        <td>100</td>
                    </tr>
                    </tbody>
                    <tr className="divider">
                        <td colSpan={2}></td>
                    </tr>
                    <tfoot>
                    <tr>
                        <td>Total Expenses</td>
                        <td>3,900</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </>
}